import { catAppAPIClient } from "@/app/apiClient";
import { GetAcademicTermsResponse } from "@anu-its/cat-grpc-pb/js/anu/cat_app/sas_pb";
import { ErrUnauthorised } from "@/app/api/Errors";
import { getCurrentUser } from "@/app/firebase/auth";

async function GetAcademicTerms(
  startYear: number,
  includeCatTerms: boolean = true,
): Promise<GetAcademicTermsResponse | Error> {
  const user = await getCurrentUser();
  if (!user) return ErrUnauthorised;

  if (startYear < 2025) {
    throw Error("Start year must be 2025 or later");
  }

  try {
    const request = {
      startYear: BigInt(startYear),
      includeCatTerms,
    };

    return await catAppAPIClient.getAcademicTerms(request);
  } catch (err) {
    console.error("GetAcademicTerms failed:", err);
    throw new Error("Failed to get academic terms. Please try again later.");
  }
}

export { GetAcademicTerms };
